import React, { useContext } from "react";
import CopyButton from "../CopyButton";
import { CodeWindow } from "../pages/CodeFeature";
import LanguageContext from "../ContextProviders/LanguageContext";
import Link from "next/link";
import Prism from "prismjs";

const typescript = `import { CovalentClient } from "@covalenthq/client-sdk";

const ApiServices = async () => {
    // Replace with your Covalent API key.
    const client = new CovalentClient("YOUR_API_KEY");
    
    // Example call, refer to API Docs for required paramaters or click into the method "getTokenBalancesForWalletAddress" to see the accepted parameter arguments
    const resp = await client.BalanceService.getTokenBalancesForWalletAddress("eth-mainnet", "WALLET_ADDRESS");
    
    if (!resp.error) {
        console.log(resp.data);
    } else {
        console.log(resp.error_message);
    }
}`;
const python = `from covalent import CovalentClient

def main():
    c = CovalentClient("YOUR_KEY")
    b = c.balance_service.get_token_balances_for_wallet_address("eth-mainnet", "demo.eth")
    if not b.error:
        print(b.data.chain_name)
    else:
        print(b.error_message)`;

const Example = (props) => {
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref.current) {
            Prism.highlightElement(ref.current, false);
        }
    }, [props.script]);

    return <><div className="wrapper">
        <div  ref={ref} className={`language-${props["data-language"]}`}>{props.script}</div><div><CopyButton text={props.script}></CopyButton></div>
    </div><style jsx>
        {`
        .wrapper {
            padding: 0.75rem 1rem;
            font-family: var(--mono);
            background: var(--code-background);
            margin: 0.25rem;
            font-size: var(--font-size-2);
            border-radius: 0rem 0rem 0.5rem 0.5rem;
            display: flex;
            justify-content: space-between;
            overflow: auto;
        }
    `}
    </style></>;
};

export const SDKExamples = () => {
    const languageContext: any = useContext(LanguageContext);

    const script = {
        "TypeScript": typescript,
        "Python": python
    };

    return <>
        <h2>SDK Quickstart</h2>
        <p>Begin your development journey swiftly by leveraging our user-friendly SDKs.</p>
        <p>Try the {languageContext?.language} SDK in your project using the code below.</p>
        <CodeWindow children={<Example data-language={languageContext?.language} script={script[languageContext?.language]}/>} hasAppBar appBarTab={languageContext?.language} />
        <p className="small">Navigate to the <Link href="/docs/unified-api/sdk/">SDKs list</Link> and find the one that matches your project's language. </p>
        <style jsx>
            {`
                .small {
                    font-size: var(--font-size-2);
                    opacity: 0.6;
                    margin-top: 0.5rem;
                }
                h2 {
                    margin-bottom: 0.75rem;
                }
                .divider {
                    padding: 0;
                    margin-top: 2rem;
                }
                .button-container {
                    display: flex;
                    gap: 1rem;
                    margin-top: 1rem;
                    margin-bottom: 1.5rem;
                }
                .container {
                    margin-bottom: var(--default-vertical-spacing);
                }
                button {
                    background: var(--code-background);
                    border: 1px solid var(--code-border);
                    padding: 0.5rem 0.75rem;
                    border-radius: var(--border-radius);
                    display: flex;
                    place-items: center;
                    gap: 0.5rem;
                    font-size: var(--font-size-2);
                }
            `}
        </style></>;
};
